import React from "react";
import Masonry from "react-masonry-css";
import YoutubeCard from "./Cards/YoutubeCard";
import RedditCard from "./Cards/RedditCard";
import TwitterCard from "./Cards/TwitterCard";
import TumblrCard from "./Cards/TumblrCard";
import FlickrCard from "./Cards/FlickrCard";

// * * Import Images *
import TwitterImg from "../asstes/twitter.png";
import TwitterWhiteImg from "../asstes/twitter_white.png";
import YoutubeImg from "../asstes/youtube.png";
import YoutubeWhiteImg from "../asstes/youtube_white.png";
import RedditImg from "../asstes/reddit.png";
import RedditWhiteImg from "../asstes/reddit_white.png";
import TumblrImg from "../asstes/tumblr.png";
import TumblrWhiteImg from "../asstes/tumblr_white.png";
import FlickrImg from "../asstes/flickr.png";
import FlickrWhiteImg from "../asstes/flickr_white.png";

function Results({ search, result, color, handleNextPage, isLoading }) {
  const [openTab, setOpenTab] = React.useState(1);
  //   console.log(result);
  const twitter = result.twitter;
  const youtube = result.youtube;
  const reddit = result.reddit;
  const tumblr = result.tumb;
  const flikr = result.flikr;

  const breakpointColumnsObj = {
    default: 4,
    1100: 3,
    700: 2,
    500: 1,
  };

  return (
    <div>
      <div className="container">
        <>
          <div className="lg:flex lg:flex-wrap">
            <div className="w-full">
              <div className="show_only_desktop">
                <ul
                  className="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row"
                  role="tablist"
                >
                  <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
                    <a
                      className={
                        "text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal " +
                        (openTab === 1 ? "tab-link active_twitter" : "tab-link")
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        setOpenTab(1);
                      }}
                      data-toggle="tab"
                      href="#link1"
                      role="tablist"
                    >
                      Twitter
                    </a>
                  </li>
                  <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
                    <a
                      className={
                        "text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal " +
                        (openTab === 4 ? "tab-link active_youtube" : "tab-link")
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        setOpenTab(4);
                      }}
                      data-toggle="tab"
                      href="#link4"
                      role="tablist"
                    >
                      Youtube
                    </a>
                  </li>
                  <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
                    <a
                      className={
                        "text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal " +
                        (openTab === 3 ? "tab-link active_reddit" : "tab-link")
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        setOpenTab(3);
                      }}
                      data-toggle="tab"
                      href="#link3"
                      role="tablist"
                    >
                      Reddit
                    </a>
                  </li>
                  <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
                    <a
                      className={
                        "text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal " +
                        (openTab === 2 ? "tab-link active_tumblr" : "tab-link")
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        setOpenTab(2);
                      }}
                      data-toggle="tab"
                      href="#link2"
                      role="tablist"
                    >
                      Tumblr
                    </a>
                  </li>
                  <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
                    <a
                      className={
                        "text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal " +
                        (openTab === 5 ? "tab-link active_flickr" : "tab-link")
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        setOpenTab(5);
                      }}
                      data-toggle="tab"
                      href="#link5"
                      role="tablist"
                    >
                      Flickr
                    </a>
                  </li>
                </ul>
              </div>
              <div className="show_only_mobile">
                <ul
                  className="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row"
                  role="tablist"
                >
                  <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
                    <a
                      className={
                        "text-xs font-bold uppercase lg:px-5 px-3 py-3 shadow-lg rounded block leading-normal " +
                        (openTab === 1 ? "tab-link active_twitter" : "tab-link")
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        setOpenTab(1);
                      }}
                      data-toggle="tab"
                      href="#link1"
                      role="tablist"
                    >
                      <img
                        src={TwitterImg}
                        alt="Twitter"
                        className="normal_tab_image"
                      />
                      <img
                        src={TwitterWhiteImg}
                        alt="Twitter"
                        className="active_tab_image"
                      />
                    </a>
                  </li>
                  <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
                    <a
                      className={
                        "text-xs font-bold uppercase lg:px-5 px-3 py-3 shadow-lg rounded block leading-normal " +
                        (openTab === 4 ? "tab-link active_youtube" : "tab-link")
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        setOpenTab(4);
                      }}
                      data-toggle="tab"
                      href="#link4"
                      role="tablist"
                    >
                      <img
                        src={YoutubeImg}
                        alt="Twitter"
                        className="normal_tab_image"
                      />
                      <img
                        src={YoutubeWhiteImg}
                        alt="Twitter"
                        className="active_tab_image"
                      />
                    </a>
                  </li>
                  <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
                    <a
                      className={
                        "text-xs font-bold uppercase lg:px-5 px-3 py-3 shadow-lg rounded block leading-normal " +
                        (openTab === 3 ? "tab-link active_reddit" : "tab-link")
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        setOpenTab(3);
                      }}
                      data-toggle="tab"
                      href="#link3"
                      role="tablist"
                    >
                      <img
                        src={RedditImg}
                        alt="Twitter"
                        className="normal_tab_image"
                      />
                      <img
                        src={RedditWhiteImg}
                        alt="Twitter"
                        className="active_tab_image"
                      />
                    </a>
                  </li>
                  <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
                    <a
                      className={
                        "text-xs font-bold uppercase lg:px-5 px-3 py-3 shadow-lg rounded block leading-normal " +
                        (openTab === 2 ? "tab-link active_tumblr" : "tab-link")
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        setOpenTab(2);
                      }}
                      data-toggle="tab"
                      href="#link2"
                      role="tablist"
                    >
                      <img
                        src={TumblrImg}
                        alt="Twitter"
                        className="normal_tab_image"
                      />
                      <img
                        src={TumblrWhiteImg}
                        alt="Twitter"
                        className="active_tab_image"
                      />
                    </a>
                  </li>
                  <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
                    <a
                      className={
                        "text-xs font-bold uppercase lg:px-5 px-3 py-3 shadow-lg rounded block leading-normal " +
                        (openTab === 5 ? "tab-link active_flickr" : "tab-link")
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        setOpenTab(5);
                      }}
                      data-toggle="tab"
                      href="#link5"
                      role="tablist"
                    >
                      <img
                        src={FlickrImg}
                        alt="Twitter"
                        className="normal_tab_image"
                      />
                      <img
                        src={FlickrWhiteImg}
                        alt="Twitter"
                        className="active_tab_image"
                      />
                    </a>
                  </li>
                </ul>
              </div>
              <div className="relative lg:flex lg:flex-col lg:min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
                <div className="lg:px-4 py-5 flex-auto">
                  <div className="tab-content tab-space">
                    <div
                      className={openTab === 1 ? "block" : "hidden"}
                      id="link1"
                    >
                      {twitter.length > 0 ? (
                        <>
                          <Masonry
                            breakpointCols={breakpointColumnsObj}
                            className="my-masonry-grid"
                            columnClassName="my-masonry-grid_column"
                          >
                            {twitter.map((item, index) => {
                              return <TwitterCard data={item} key={index} />;
                            })}
                          </Masonry>
                          <div className="text-center result_footer">
                            {isLoading ? (
                              <button className="load_more_button">
                                Loading...
                              </button>
                            ) : (
                              <button
                                className="load_more_button"
                                onClick={handleNextPage}
                              >
                                Load More...
                              </button>
                            )}
                          </div>
                        </>
                      ) : (
                        <div className="w-full bg-yellow-100 rounded-xl p-5">
                          <span>
                            Data not available for the search "{search}"
                          </span>
                        </div>
                      )}
                    </div>
                    <div
                      className={openTab === 2 ? "block" : "hidden"}
                      id="link2"
                    >
                      {tumblr.length > 0 ? (
                        <>
                          <Masonry
                            breakpointCols={breakpointColumnsObj}
                            className="my-masonry-grid"
                            columnClassName="my-masonry-grid_column"
                          >
                            {tumblr.map((item, index) => {
                              return <TumblrCard data={item} key={index} />;
                            })}
                          </Masonry>
                          <div className="text-center result_footer">
                            {isLoading ? (
                              <button className="load_more_button">
                                Loading...
                              </button>
                            ) : (
                              <button
                                className="load_more_button"
                                onClick={handleNextPage}
                              >
                                Load More...
                              </button>
                            )}
                          </div>
                        </>
                      ) : (
                        <div className="w-full bg-yellow-100 rounded-xl p-5">
                          <span>
                            Data not available for the search "{search}"
                          </span>
                        </div>
                      )}
                    </div>
                    {/* Reddit data */}
                    <div
                      className={openTab === 3 ? "block" : "hidden"}
                      id="link3"
                    >
                      {reddit.length > 0 ? (
                        <>
                          <Masonry
                            breakpointCols={breakpointColumnsObj}
                            className="my-masonry-grid"
                            columnClassName="my-masonry-grid_column"
                          >
                            {reddit.map((item, index) => {
                              return <RedditCard data={item} key={index} />;
                            })}
                          </Masonry>
                          <div className="text-center result_footer">
                            {isLoading ? (
                              <button className="load_more_button">
                                Loading...
                              </button>
                            ) : (
                              <button
                                className="load_more_button"
                                onClick={handleNextPage}
                              >
                                Load More...
                              </button>
                            )}
                          </div>
                        </>
                      ) : (
                        // RedditCard
                        <div className="w-full bg-yellow-100 rounded-xl p-5">
                          <span>
                            Data not available for the search "{search}"
                          </span>
                        </div>
                      )}
                    </div>
                    <div
                      className={openTab === 4 ? "block" : "hidden"}
                      id="link3"
                    >
                      {youtube.length > 0 ? (
                        <>
                          <Masonry
                            breakpointCols={breakpointColumnsObj}
                            className="my-masonry-grid"
                            columnClassName="my-masonry-grid_column"
                          >
                            {youtube.map((item, index) => {
                              return <YoutubeCard data={item} key={index} />;
                            })}
                          </Masonry>
                          <div className="text-center result_footer">
                            {isLoading ? (
                              <button className="load_more_button">
                                Loading...
                              </button>
                            ) : (
                              <button
                                className="load_more_button"
                                onClick={handleNextPage}
                              >
                                Load More...
                              </button>
                            )}
                          </div>
                        </>
                      ) : (
                        <div className="w-full bg-yellow-100 rounded-xl p-5">
                          <span>
                            Data not available for the search "{search}"
                          </span>
                        </div>
                      )}
                    </div>
                    <div
                      className={openTab === 5 ? "block" : "hidden"}
                      id="link5"
                    >
                      {flikr.length > 0 ? (
                        <>
                          <Masonry
                            breakpointCols={breakpointColumnsObj}
                            className="my-masonry-grid"
                            columnClassName="my-masonry-grid_column"
                          >
                            {flikr.map((item, index) => {
                              return <FlickrCard data={item} key={index} />;
                            })}
                          </Masonry>
                          <div className="text-center result_footer">
                            {isLoading ? (
                              <button className="load_more_button">
                                Loading...
                              </button>
                            ) : (
                              <button
                                className="load_more_button"
                                onClick={handleNextPage}
                              >
                                Load More...
                              </button>
                            )}
                          </div>
                        </>
                      ) : (
                        <div className="w-full bg-yellow-100 rounded-xl p-5">
                          <span>
                            Data not available for the search "{search}"
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      </div>
    </div>
  );
}
export default Results;
